import { createRelayResource } from '@townsquare/relay-utils';

import ProjectHeaderRefreshedQuery, {
	type ProjectHeaderRefreshedQuery as ProjectHeaderRefreshedQueryType,
} from '../components/ProjectHeaderRefreshed/__generated__/ProjectHeaderRefreshedQuery.graphql';

export const projectViewHeaderResource = createRelayResource<ProjectHeaderRefreshedQueryType>({
	getQuery: (routerContext) => {
		return {
			query: ProjectHeaderRefreshedQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
			},
		};
	},
});
